import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { useDispatch, useSelector } from "react-redux";
import { createSubscriptionAction } from "../../redux/actions/userAction";
import axios from "axios";
import { server_endpoint } from "../../redux/store";
import { Toaster, toast } from "react-hot-toast";
import {TiTick} from 'react-icons/ti'
const Pricing = ({user}) => {
  const dispatch = useDispatch();

  const [key, setKey] = useState("");
  const { loading, error, subscriptionId } = useSelector(
    (state) => state.subscription
  );
  // console.log(loading)

  const subscribeHandler = async () => {
    const { data } = await axios.get(`${server_endpoint}/getkey`);
    setKey(data.key);

    dispatch(createSubscriptionAction());
  };
  useEffect(() => {
    if (loading) {
      toast.success('Sending Request');
    }

    if (error) {
      toast.error(error);
      dispatch({
        type: "clearError",
      });
    }

    if (subscriptionId) {
      const openPopUp = () => {


        const options = {

          key,
          amount:"159900",
          name:"Pro Pack",
          description: "Get access to all contents",
          image : "",
          subsciption_id: subscriptionId,
        //   handler: function (response){
        //     alert(response.razorpay_payment_id);
        //     alert(response.razorpay_order_id);
        //     alert(response.razorpay_signature)
        // },

        callback_url:`${server_endpoint}/verifypayment`,
          prefill: {
            name: user.name, //your customer's name
        email: user.email, 
        contact: ""
          },
          notes: {
            address: "Razorpay Corporate Office"
        },
        theme: {
          color: "#3399cc"
      }

        }

        const razor = new window.Razorpay(options)
        razor.open()



      };

      openPopUp();
    }
  }, [dispatch, error, loading, user?.name, user?.email, key, subscriptionId]);

  return (
    <>
    <Toaster/>
      <Navbar />
      <div className=" flex flex-col justify-center items-center h-[660px] py-24 my-auto text-white  w-full">
        <div className="bg-brand_jaguar  h-[400px] lg:h-[400px] rounded-t-lg flex flex-col justify-start text-center  items-center w-[300px] lg:w-[400px]">
          <h1 className="text-xl py-1 text-black rounded-t-lg font-semibold bg-brand_yellow w-full">
            Pro
          </h1>
          <div className="py-3 my-4 flex justify-center items-center">
            <h1 className="text-4xl  font-semibold mx-1">₹ 1599</h1>
            <h1 className="text-sm font-semibold text-gray-400">{" "}/ MO</h1>
          </div>
          <div className="my-8">
          <div className=" flex items-center">
            <span className="text-brand_yellow mx-1"><TiTick/></span><h1 >  Access to all Videos</h1>
          </div>
          <div className="flex items-center">            
          <span className="text-brand_yellow mx-1"><TiTick/></span><h1 >  Access to all Blogs and Contents</h1>    
          </div>
          <div className=" flex items-center">
          <span className="text-brand_yellow mx-1"><TiTick/></span><h1 >Priority Support</h1>
          </div>

          </div>
          
          

          <div className="text-center mt-8">
           
            <button disabled={loading}
            
              onClick={() => {
                subscribeHandler();
              }}
              className={`uppercase rounded-md transition hover:scale-105 ease-out duration-200  w-full ${loading ? 'bg-yellow-100 text-gray-600' : 'bg-brand_yellow text-black'} text-sm px-6 font-semibold py-2`}  >
              GET STARTED
            </button>
          </div>
        </div>

        <div className="text-black text-center my-2 w-[400px]">
          Guaranteed Safe & Secure checkout
        </div>
      </div>
    </>
  );
};

export default Pricing;
